import { HttpClient } from '@packages/shared/core/common/services';
import { ApiPathAskGateway } from '@packages/shared/core/common/constants/apiPaths';
import { mapCreateChatDtoToEntity } from '../mappers';
import { CreateChatTypeDto } from './dto';

export class ChatService {
  constructor(private readonly httpClient: HttpClient) {}

  async createChat(expertId: string) {
    const { data } = await this.httpClient.post<CreateChatTypeDto>(ApiPathAskGateway.CHAT_MESSAGE_CHATS, {
      data: { expert_id: expertId },
    });

    return mapCreateChatDtoToEntity(data);
  }
}
